import React, { useEffect, useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { app } from '../util/firebase';
import { collection, getFirestore, onSnapshot } from 'firebase/firestore';

const Test = () => {
    const [allUsers,setAllUsers] = useState([])
    useEffect(()=>{
        let myArray = []
        onSnapshot(collection(getFirestore))
    },[])

    const getAllUsers=()=>{
        
    }
    return (    
        <div>
        Test
            {getAllUsers()}
        </div>
    );
};

export default Test;